import { api } from "@/services";
import { API_ENDPOINTS } from "@/config";
import { isAddress } from "viem";
import type { UserHistoryData, UserHistoryResponse, UserHistoryType } from "@/types/api.types";

const fetchUserHistory = async (address: string, daysAgo: number, type: UserHistoryType): Promise<UserHistoryData> => {
    if (!isAddress(address)) throw new Error("Address is required to fetch user history");

    const endpoint =
        type === "tvl"
            ? API_ENDPOINTS.PROTOCOL.USER_HISTORY.GET_USER_TVL_HISTORY(address, daysAgo)
            : API_ENDPOINTS.PROTOCOL.USER_HISTORY.GET_USER_PNL_HISTORY(address, daysAgo);

    try {
        const response = await api.get<UserHistoryResponse>(endpoint);
        return response.data.data;
    } catch (error) {
        console.error("Error fetching user history:", error);
        throw error;
    }
};

export const fetchUserTvlHistory = (address: string, daysAgo: number): Promise<UserHistoryData> =>
    fetchUserHistory(address, daysAgo, "tvl");

export const fetchUserPnlHistory = (address: string, daysAgo: number): Promise<UserHistoryData> =>
    fetchUserHistory(address, daysAgo, "pnl");
